import { render, staticRenderFns } from "./PivotTable.vue?vue&type=template&id=b2bed700&"
import script from "./PivotTable.vue?vue&type=script&lang=ts&"
export * from "./PivotTable.vue?vue&type=script&lang=ts&"
import style0 from "./PivotTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports